import React, { useState } from 'react';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import moment from 'moment';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import { 
  MdAccessTime, 
  MdEvent, 
  MdVolumeUp, 
  MdClose, 
  MdPerson, 
  MdPhone, 
  MdEmail, 
  MdLocationOn, 
  MdPeople, 
  MdNotes, 
  MdCheckCircle 
} from 'react-icons/md';




const localizer = momentLocalizer(moment);





const AppointmentBooking = ({



    // State values
    selectedDate,
    formData,
    showForm,
    submissionSuccess,
    currentMonth,
    activeTab,
    bookedDates,
    bookedEvents,
    timeSlots,
    selectedMealType,
    selectedEvent,
    formDonateData,
    isSubmitting,
    
    // State setters
    setSelectedDate,
    setFormData,
    setShowForm,
    setSubmissionSuccess,
    setCurrentMonth,
    setActiveTab,
    setBookedDates,
    setBookedEvents,
    setTimeSlots,
    setSelectedMealType,
    setSelectedEvent,
    setFormDonateData,
    setIsSubmitting,
    
    // Handlers
    handleInputChange,
    navigateMonth,
    handleAlmsDateSelect,
    almsEventStyleGetter,
    handleDhammaDateSelect,
    handleTimeSlotSelect,
    dhammaEventStyleGetter,
    handleSubmit,
    handleChange,
    handleDonateSubmit,
    CustomToolbar
  }) => {
    




const [bookingError, setBookingError] = useState('');

  return (
    <div className="appointment-container">
      <div className="booking-tabs">
        <button
          className={`tab-button ${activeTab === 'alms' ? 'active' : ''}`}
          onClick={() => setActiveTab('alms')}
        >
          Alms Giving
        </button>
        <button
          className={`tab-button ${activeTab === 'dhamma' ? 'active' : ''}`}
          onClick={() => setActiveTab('dhamma')}
        >
          Dhamma Speech/Pirith Chanting
        </button>
        <button 
          className={`tab-button ${activeTab === 'monastery' ? 'active' : ''}`} 
          onClick={() => setActiveTab('monastery')}
        >
          Daily expenses of the monastery
        </button>
      </div>

      {activeTab === 'monastery' && (
        <div className="donation-container">
          <h3>Daily Expenses of Monastery</h3>
          <div className="donation-form-layout">
            <div className="form-column">
              <form onSubmit={handleDonateSubmit}>
                <div className="form-group">
                  <label htmlFor="firstName">First Name</label>
                  <input 
                    type="text" 
                    id="firstName" 
                    value={formDonateData.firstName}
                    onChange={handleChange}
                    required
                  />
                </div>
                
                <div className="form-group">
                  <label htmlFor="lastName">Last Name</label>
                  <input 
                    type="text" 
                    id="lastName" 
                    value={formDonateData.lastName}
                    onChange={handleChange}
                    required
                  />
                </div>
                
                <div className="form-group">
                  <label htmlFor="email">Email Address</label>
                  <input 
                    type="email" 
                    id="email" 
                    value={formDonateData.email}
                    onChange={handleChange}
                    required
                  />
                </div>
                
                <div className="form-group">
                  <label htmlFor="phone">Phone Number</label>
                  <input 
                    type="tel" 
                    id="phone" 
                    value={formDonateData.phone}
                    onChange={handleChange}
                    required
                  />
                </div>
                
                <div className="form-group">
                  <label htmlFor="address">Address</label>
                  <textarea 
                    id="address" 
                    value={formDonateData.address}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="donationDate">Select a Date</label>
                  <input
                    type="date"
                    id="date"
                    value={formDonateData.date}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="amount">Amount</label>
                  <input 
                    type="number" 
                    id="amount" 
                    value={formDonateData.amount}
                    onChange={handleChange}
                    required
                  />
                </div>
                
                <div className="form-group">
                  <label htmlFor="reason">Reason for the Donation</label>
                  <textarea 
                    id="reason" 
                    value={formDonateData.reason}
                    onChange={handleChange}
                  />
                </div>
                
                <button 
                  type="submit" 
                  className="submit-button"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? 'Submitting...' : 'Submit Details'}
                </button>
              </form>
            </div>
            
            <div className="details-column">
              <div className="bank-info">
                <p>With a heart full of gratitude, we humbly invite you to contribute towards the daily expenses of the monastery.
                Your generous offering, however small, helps sustain the spiritual activities and serene environment that benefit all beings.</p>
                <p><b>Kindly request to send your transaction slip to our WhatsApp Account (+61 45 12 900 85). Thank you! 🙏</b></p>
                <br/>
                <h4>Bank Account Information:</h4>
                <p><strong>Bank:</strong> Commonwealth Bank</p>
                <p><strong>Account Name:</strong> ENLIGHTENED PATH FELLOWSHIP INC.</p>
                <p><strong>BSB:</strong> 063-599</p>
                <p><strong>Account number:</strong> 1128 2820</p>
                <p><strong>BIC/SWIFT Code:</strong> CTBAAU2S</p>
              </div>
            </div>
          </div>
        </div>
      )}

      {activeTab === 'alms' ? (
        <>
          <div className="appointment-header">
            <h1 className="appointment-title">Alms Giving Appointment</h1>
            <p className="appointment-subtitle">Select a date for your alms giving offering</p>
            {/* <p><b>Note:</b>There are two Buddhist monks residing at the monastery.</p> */}
          </div>

          <div className="legend-container">
            <div className="legend-item">
              <span className="legend-color breakfast"></span>
              <span>Breakfast Offering (6:00 AM - 8:00 AM)</span>
            </div>
            <div className="legend-item">
              <span className="legend-color lunch"></span>
              <span>Lunch Offering (10:30 AM - 12:30 PM)</span>
            </div>
            <div className="legend-item">
              <span className="legend-color booked"></span>
              <span>Booked Dates</span>
            </div>
            <div className="legend-item">
              <span className="legend-color past"></span>
              <span>Past Dates</span>
            </div>
          </div>



      <div className='alert-box'>
        <h4 className='alert-box-message'>To access the appointment form, press and hold the desired date</h4>
      </div>




          <div className="calendar-container">
            <div className="meal-calendar">
              <div className="calendar-header">
                <h2>
                  <MdAccessTime className="meal-icon" /> 
                  Breakfast Offering
                  <span className="time-slot">6:00 AM - 8:00 AM</span>
                </h2>
              </div>

              <Calendar
                localizer={localizer}
                defaultView="month"
                views={['month']}
                selectable
                onSelectSlot={(slotInfo) => handleAlmsDateSelect(slotInfo.start, 'breakfast')}
                dayPropGetter={(date) => almsEventStyleGetter(date, 'breakfast')}
                min={new Date()}
                style={{ height: 420 }}
                date={currentMonth}
                onNavigate={(date) => setCurrentMonth(date)}
                components={{
                  toolbar: CustomToolbar
                }}
              />
            </div>

            <div className="meal-calendar">
              <div className="calendar-header">
                <h2>
                  <MdAccessTime className="meal-icon" /> 
                  Lunch Offering
                  <span className="time-slot">10:30 AM - 12:30 PM</span>
                </h2>
              </div>
              <Calendar
                localizer={localizer}
                defaultView="month"
                views={['month']}
                selectable
                onSelectSlot={(slotInfo) => handleAlmsDateSelect(slotInfo.start, 'lunch')}
                dayPropGetter={(date) => almsEventStyleGetter(date, 'lunch')}
                min={new Date()}
                style={{ height: 420 }}
                date={currentMonth}
                onNavigate={(date) => setCurrentMonth(date)}
                components={{
                  toolbar: CustomToolbar
                }}
              />

            </div>
          </div>






        </>
      ) : activeTab === 'dhamma' && (
        <>
          <div className="booking-header">
            <h1 className="booking-title">Dhamma Speech & Pirith Chanting Booking</h1>
            <p className="booking-subtitle">Schedule your spiritual event with our venerable monks</p>
          </div>

          <div className="legend-container">
            <div className="legend-item">
              <span className="legend-color available"></span>
              <span>Available Dates</span>
            </div>
            <div className="legend-item">
              <span className="legend-color has-bookings"></span>
              <span>Dates with Bookings</span>
            </div>
            <div className="legend-item">
              <span className="legend-color past"></span>
              <span>Past Dates</span>
            </div>
          </div>

          <div className="calendar-container">
            <div className="dhamma-calendar">
              <div className="calendar-header">
                <h2>
                  <MdEvent className="event-icon" /> 
                  Available Dates
                </h2>
              </div>


{/********************************************************************************************************************/}


              <div className='alert-box'>
                <h4 className='alert-box-message'>To access the appointment form, press and hold the desired date</h4>
              </div>


              <Calendar
                localizer={localizer}
                defaultView="month"
                views={['month']}
                selectable
                onSelectSlot={(slotInfo) => handleDhammaDateSelect(slotInfo.start)}
                dayPropGetter={(date) => dhammaEventStyleGetter(date)}
                min={new Date()}
                style={{ height: 420 }}
                date={currentMonth}
                onNavigate={(date) => setCurrentMonth(date)}
                components={{
                  toolbar: CustomToolbar
                }}
              />
            </div>

            {selectedDate && (
              <div className="time-slots-container">
                <div className="time-slots-header">
                  <h2>
                    <MdVolumeUp className="event-icon" /> 
                    Available Time Slots for {moment(selectedDate).format('LL')}
                  </h2>
                </div>
                <div className="time-slots-grid">
                  {timeSlots.map((slot, index) => (
                    <div 
                      key={index}
                      className={`time-slot-card ${slot.isPast ? 'past-slot' : ''} ${slot.isBooked ? 'booked-slot' : ''}`}
                      onClick={() => !slot.isPast && !slot.isBooked && handleTimeSlotSelect(slot)}
                    >
                      <div className="slot-time">
                        <MdAccessTime />
                        {slot.time}
                      </div>
                      <div className="slot-status">
                        {slot.isPast ? (
                          <span className="status-badge past">Time Passed</span>
                        ) : slot.isBooked ? (
                          <span className="status-badge booked">Booked</span>
                        ) : (
                          <button className="book-button">Book Appointment</button>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        </>
      )}

      {showForm && (
        <div className="appointment-form-overlay">
          <div className="appointment-form-container">
            <div className="form-header">
              <h3>
                {activeTab === 'alms' 
                  ? `${selectedMealType === 'breakfast' ? 'Breakfast' : 'Lunch'} Offering`
                  : 'Pirith Chanting / Dhamma Speech'}
                <span className="form-date">{moment(selectedDate).format('LL')}</span>
              </h3>
              <button 
                className="close-form" 
                onClick={() => setShowForm(false)}
              >
                <MdClose />
              </button>
            </div>
            
            <div className="time-display">
              <MdAccessTime />
              {activeTab === 'alms'
                ? selectedMealType === 'breakfast' ? '6:00 AM - 8:00 AM' : '10:30 AM - 12:30 PM'
                : selectedEvent?.time}
            </div>

            <form onSubmit={handleSubmit} className="appointment-form">



            {/*error message  */}
            {bookingError && (
              <div className="error-box">
                ❌ {bookingError}
              </div>
            )}




              <div className="form-group">
                <label>
                  <MdPerson className="input-icon" /> Full Name
                </label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleInputChange}
                  required
                  placeholder="Enter your full name"
                />
              </div>

              <div className="form-group">
                <label>
                  <MdPhone className="input-icon" /> Phone Number
                </label>
                <input
                  type="tel"
                  name="phone"
                  value={formData.phone}
                  onChange={handleInputChange}
                  required
                  placeholder="Enter your phone number"
                />
              </div>

              <div className="form-group">
                <label>
                  <MdEmail className="input-icon" /> Email
                </label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  required
                  placeholder="Enter your email address"
                />
              </div>

              <div className="form-group">
                <label>
                  <MdLocationOn className="input-icon" /> Address
                </label>
                <input
                  type="text"
                  name="address"
                  value={formData.address}
                  onChange={handleInputChange}
                  required
                  placeholder="Enter your address"
                />
              </div>

              <div className="form-group">
                <label>
                  <MdPeople className="input-icon" /> 
                  {activeTab === 'alms' ? 'Number of Monks' : 'Expected Attendees'}
                </label>
                <input
                  type="number"
                  name="numberOfPeople"
                  min="1"
                  max={activeTab === 'alms' ? "50" : "100"}
                  value={formData.numberOfPeople}
                  onChange={handleInputChange}
                  required
                />
              </div>

              {activeTab === 'alms' && (
                <div className="form-group">
                  <label>
                    <MdLocationOn className="input-icon" /> Location for Offering
                  </label>
                  <select
                    name="location"
                    value={formData.location}
                    onChange={handleInputChange}
                    required
                    className="location-select"
                  >
                    <option value="">Select a location</option>
                    <option value="Ehipassiko Buddhist Centre">Ehipassiko Buddhist Centre</option>
                    <option value="My Home (Above Address)">My Home (Above Address)</option>
                  </select>
                </div>
              )}

              <div className="form-group">
                <label>
                  <MdNotes className="input-icon" /> Special Requests
                </label>
                <textarea
                  name="specialRequests"
                  value={formData.specialRequests}
                  onChange={handleInputChange}
                  rows="3"
                  placeholder={
                    activeTab === 'alms' 
                      ? 'Any special requirements or notes'
                      : 'Any special requirements or topics for Dhamma speech'
                  }
                />
              </div>

              <div className="form-actions">
                <button type="button" className="cancel-btn" onClick={() => setShowForm(false)}>
                  Cancel
                </button>
  
                <button 
                  type="submit" 
                  className="submit-btn"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? (
                    <>
                      <span className="spinner"></span> Processing...
                    </>
                  ) : (
                    'Confirm Booking'
                  )}
                </button>

              </div>
            </form>
          </div>
        </div>
      )}

      {submissionSuccess && (
        <div className="success-message-overlay">
          <div className="success-message">
            <MdCheckCircle className="success-icon" />
            <h3>Booking Confirmed Successfully!</h3>
            <p>
              Your {activeTab === 'alms'
                ? `${selectedMealType} offering on ${moment(selectedDate).format('LL')}`
                : `Pirith Chanting / Dhamma Speech on ${moment(selectedDate).format('LL')} at ${selectedEvent?.time}`} 
              has been booked.
            </p>
            <p>Successfully Submitted.</p>
            <button 
              className="success-close-btn"
              onClick={() => setSubmissionSuccess(false)}
            >
              Close
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default AppointmentBooking;